import { render, staticRenderFns } from "./MemberAgreement.vue?vue&type=template&id=54b616b1&scoped=true"
import script from "./MemberAgreement.vue?vue&type=script&lang=js"
export * from "./MemberAgreement.vue?vue&type=script&lang=js"
import style0 from "./MemberAgreement.vue?vue&type=style&index=0&id=54b616b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b616b1",
  null
  
)

export default component.exports